import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  EVALUATION_SURVEY_FEATURE_KEY,
  EvaluationSurveyState,
} from './evaluation-survey.reducer';

export const selectEvaluationSurveyState = createFeatureSelector<EvaluationSurveyState>(
  EVALUATION_SURVEY_FEATURE_KEY,
);

export const selectEvaluationSurveySurveys = createSelector(
  selectEvaluationSurveyState,
  state => state?.data ?? [],
);

export const selectEvaluationSurveyLoaded = createSelector(
  selectEvaluationSurveyState,
  state => (state?.data?.length ?? 0) > 0,
);

export const selectEvaluationSurveyLoading = createSelector(
  selectEvaluationSurveyState,
  state => state?.loading ?? false,
);

export const selectEvaluationSurveyError = createSelector(
  selectEvaluationSurveyState,
  state => state?.error != null,
);
